<template lang="pug">
.challenges-about
  .about-content
    .loading(v-if="loading")
      p {{ __('Loading...') }}

    template(v-else-if="contentBlocks.length > 0")
      component(
        v-for="(block, index) in contentBlocks"
        :is="RenderBlock"
        :key="index"
        :block="block"
      )

    p.no-content(v-else) {{ __('Content not available.') }}

  .view-leaderboard
    RogueButton(
      width="full"
      color="black"
      @click="goToLeaderboard"
    ) {{ __('View Leaderboard') }}
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useRogue } from '@/js/services/Rogue'
import { useCmsStore } from '@/js/stores/cmsStore'
import { ROGUE_APP_SPA_URL_PREFIX } from '@/js/app-bridge/helpers'
import { messages } from '@/js/app-bridge/messages'
import RenderBlock from 'sisu/components/RenderBlock'

const router = useRouter()
const rogue = useRogue()
const cmsStore = useCmsStore()

const loading = ref(true)
const cmsPage = ref<any>(null)

const CMS_PAGE_ID = 'challenges'

const contentBlocks = computed(() => {
  const rb = cmsPage.value?.roguebuilder
  if (!rb) return []
  if (Array.isArray(rb)) return rb
  return [rb]
})

async function loadCmsContent() {
  loading.value = true
  try {
    cmsPage.value = await cmsStore.load(CMS_PAGE_ID, rogue)
  } catch (e) {
    rogue.log.error('Error loading challenges CMS content', e)
  } finally {
    loading.value = false
  }
}

function goToLeaderboard() {
  router.push(`${ROGUE_APP_SPA_URL_PREFIX}challenges/leaderboard`)
}

onMounted(async () => {
  if (!rogue.appContext && !rogue.featureFlags.isOn('invitational_app_display')) {
    router.replace('/challenges')
    return
  }
  await loadCmsContent()
  if (rogue.appContext) {
    rogue.emitToApp(messages.DOM_LOADED, {})
  }
})
</script>

<style lang="scss" scoped>
.challenges-about {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: $color-white;
}

.about-content {
  flex: 1;
}

.loading,
.no-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: $space-xl;
  color: $color-gray-dark;
}

.view-leaderboard {
  padding: $space-m;
  position: sticky;
  bottom: 0;
  background: $color-white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
</style>

<style lang="scss">
.platform-ios, .platform-android {
  body:has(.challenges-about) {
    overscroll-behavior-y: none;
  }

  .challenges-about {
    padding-top: $space-xs;
    .view-leaderboard {
      padding-bottom: calc(#{$space-m} + env(safe-area-inset-bottom, 0px));
    }
  }

  // Hide content not meant for native app
  .rogue-hide:not(.rg-show-native) {
    display: none;
  }
}
</style>
